module.exports = __webpack_public_path__ + "img/img4.3a3d368c.png";